<!-- added by priya 03-12-2025 -->
@if(!templateForPermitForm){<h3>Users</h3>}
@else{
  <wm-common-text [data]="{ text: 'Users' }" class="header">
  </wm-common-text>

}
<!-- end by priya 03-12-2025 -->
<div
  *ngIf="statusMessage && statusMessage !== null && statusMessage !== ''"
  [class]="alertClass"
  role="alert"
>
  {{ statusMessage }}
</div>

<wm-user-search
  (searchStarted)="searchStarted()"
  (searchFinished)="searchFinished($event)"
  [searchText]="searchText"
>
</wm-user-search>

<wm-user-list
  [users]="users"
  [raiseEvent]="raiseEvent"
  [searching]="searching"
  (selected)="userSelected($event)"
></wm-user-list>
